import { Pipe, PipeTransform } from '@angular/core';
import { ContractStatusEnum } from '../../enums/contract-status.enum';

@Pipe({
  name: 'contractStatus',
})
export class ContractStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case ContractStatusEnum.NEW:
        return 'bg-primary-500';
      case ContractStatusEnum.APPROVED:
        return 'bg-success-500';
      case ContractStatusEnum.UNDER_MODIFICATION:
        return 'bg-warning-500';
      case ContractStatusEnum.REJECTED:
        return 'bg-destructive-500';
      case ContractStatusEnum.CANCELLED:
        return 'bg-destructive-500';
    }
    return '';
  }
}
